export default __webpack_public_path__ + "media/pins/map-pin-brown-hover@2x-f49c31ee.png";